import Vue from 'vue'
import app from './app'
export default {
  namespaced: true,
  state: {
    // 选择项目下拉展示项目数量
    moreNum: 100,
    dialogVisible: false,
    showForm: '',
    // 财务侧边关联栏是否隐藏
    sideBarShow: false,
    containerType: '0',
    // 财务侧边关联列表
    aboutList: [],
    formData: {
      is_draft: '0'
    },
    list: [],
    Total: 0,
    // 表单搜索
    searchDateSatrt: '',
    searchDateEnd: '',
    search_member_id: '',
    searchInfo: '',
    searchIsArchive: '0',
    searchType: '',
    currentPage: 1,
    pageSize: 10,

    // 草稿禁用
    draftDisable: false,
    // 判断是否财务禁用
    isAdmin1: false,
    isAdmin2: false,
    isAdmin3: false,
    isAdmin4: false,
    isAdmin5: false,
    isAdmin6: false,
    isAdmin7: false,
    isAdmin8: false,
    // 项目列表
    projectList: [],
    // 项目列表(截取后)
    projectListSub: [],
    // 预设审批人列表
    list3: [],

  },
  mutations: {
    setprojectListSub(state, data) {
      state.projectListSub = data
    },
    // 预设审批人列表
    setList3(state, val) {
      state.list3 = val
    },
    getDialogVisible(state, val) {
      state.dialogVisible = val
    },
    getAboutList(state, val) {
      state.aboutList = val
    },
    getSideBarShow(state, val) {
      state.sideBarShow = val
    },
    // containerType赋值
    getContainerType(state, val) {
      state.containerType = val
    },
    // showForm赋值
    getShowForm(state, val) {
      state.showForm = val
    },
    // FormData赋值
    getFormData(state, data) {
      state.formData = data
    },
    // draftDisable赋值
    getDraftDisable(state, data) {
      state.draftDisable = data
    },
    // *1邮寄列表
    async getMailList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')

      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_mail'
      } else {
        urlStr = '/api/Service/mail'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }



      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin1 = res.datas.admin_state
    },
    // *2报告用章列表
    async getReportList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')

      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_report'
      } else {
        urlStr = '/api/Service/report'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }

      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin2 = res.datas.admin_state
    },
    // *3其他用章列表
    async getChapterList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')

      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_chapter'
      } else {
        urlStr = '/api/Service/chapter'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }

      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin3 = res.datas.admin_state
    },
    // *4合同用章列表
    async getHtList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')


      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_contract_seal'
      } else {
        urlStr = '/api/Service/contract_seal'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('is_archive', state.searchIsArchive || '0')
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }
      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin4 = res.datas.admin_state
    },
    // *5合同存档列表
    async getHtSaveList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')


      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_contract_archive'
      } else {
        urlStr = '/api/Service/contract_archive'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }
      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin5 = res.datas.admin_state
    },
    // *6合同存档列表
    async getExtrenalList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')


      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_external_seal'
      } else {
        urlStr = '/api/Service/external_seal'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('search_member_id', state.search_member_id)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }
      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin6 = res.datas.admin_state
    },
    // *7公示存档列表（无审批）
    async getAnnounceList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')

      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_announce'
      } else {
        urlStr = '/api/Service/announce'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }
      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin7 = res.datas.admin_state
    },
    // *8告知书列表（无审批）
    async getNotifyList(state, project_id) {
      let param = new FormData()
      let urlStr = ''
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')

      if (project_id) {
        param.append('project_id', project_id)
        param.append('p', 1)
        param.append('p_count', 10000)
        urlStr = '/api/Finance/ass_notify'
      } else {
        urlStr = '/api/Service/notify'
        param.append('search', state.searchInfo)
        param.append('date_start', state.searchDateSatrt)
        param.append('date_end', state.searchDateEnd)
        param.append('p', state.currentPage)
        param.append('p_count', state.pageSize)
      }
      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: urlStr,
        data: param,
      })
      if (res.code != 200) return Vue.prototype.error(res.datas.msg)
      state.list = res.datas.listInfo
      state.Total = parseInt(res.datas.count)
      state.isAdmin8 = res.datas.admin_state
    },



    // 表单搜索赋值
    assignmentSearchDateSatrt(state, data) {
      state.searchDateSatrt = data
    },
    assignmentSearchDateEnd(state, data) {
      state.searchDateEnd = data
    },
    assignmentSearch_member_id(state, data) {
      state.search_member_id = data
    },
    assignmentSearchInfo(state, data) {
      state.searchInfo = data
    },
    assignmentSearchIsArchive(state, data) {
      state.searchIsArchive = data
    },
    assignmentSearchType(state, data) {
      state.searchType = data
    },
    assignmentCurrentPage(state, data) {
      state.currentPage = data
    },
    assignmentPageSize(state, data) {
      state.pageSize = data
    },

    // projectList赋值
    assignmentProject(state, data) {
      state.projectList = data
    },
    // 清空列表
    emptyList(state) {
      state.list = []
    },
    // 清空列表
    emptyFormData(state) {
      state.formData = {
        is_draft: '0'
      }
    },
  },
  actions: {

  },
  getters: {
    finance_stage: (state) => {
      // 邮寄
      if (state.showForm == 'showFormAdd' || state.showForm == 'showFormHandle') {
        return 'mail'
      }
      if (state.showForm == 'showFormClearAdd' || state.showForm == 'showFormClearHandle') {
        return 'report'
      }
      if (state.showForm == 'showFormZhuanAdd' || state.showForm == 'showFormZhuanHandle') {
        return 'chapter'
      }
      if (state.showForm == 'showFormHtAdd' || state.showForm == 'showFormHtHandle') {
        return 'contract_seal'
      }
      if (state.showForm == 'showFormHtSaveAdd' || state.showForm == 'showFormHtSaveHandle') {
        return 'contract_archive'

      }
      if (state.showForm == 'showFormExtrenalAdd' || state.showForm == 'showFormExtrenalHandle') {
        return 'external_seal'
      }
      if (state.showForm == 'showFormAnnounceAdd' || state.showForm == 'showFormAnnounceHandle') {
        return 'announce'
      }
      if (state.showForm == 'showFormNotifyAdd' || state.showForm == 'showFormNotifyHandle') {
        return 'notify'
      }

    }
  },
}
